import { QueryFormatFilter, QueryListFilter, QueryMapFilter } from '@hotjar/global-filters';
import { JsonFilters } from '../store/list/types';

export const getOneYearAgoDateRangeTimestamps = (): number[] => {
  const currentTimestamp = Math.floor(Date.now() / 1000);
  const oneYearAgoTimestamps = currentTimestamp - 365 * 24 * 60 * 60;

  return [oneYearAgoTimestamps, currentTimestamp];
};

export const generateRequestFilters = (
  jsonFilters: QueryFormatFilter,
  recordingsRequestTimeRange: number[],
): JsonFilters => {
  const filtersArray = (jsonFilters as QueryListFilter)?.AND
    ? [...((jsonFilters as QueryListFilter).AND as QueryMapFilter[])]
    : [jsonFilters];

  // We need to recreate the /recordings request with the RANGE_IN equal to the values returned by backend and stored in the LS.
  // Clickhouse is not able to join two `create` filters into one common peroid.
  // This is why we're removing the current `create` filter and replace it with fixed `RANGE_IN` value.
  const filtersWithoutCreatedFilter = filtersArray.filter((filter) => {
    return (
      filter &&
      Object.keys(filter).length > 0 &&
      Object.keys(filter).every((key) => key !== 'RANGE_IN' && key !== 'DAYS_AGO')
    );
  });

  // Fallback to the default values when we're missing the timestamps
  const requestDateRange =
    recordingsRequestTimeRange && recordingsRequestTimeRange.length === 2
      ? recordingsRequestTimeRange
      : getOneYearAgoDateRangeTimestamps();

  const rangeInFilter = {
    RANGE_IN: {
      created: requestDateRange,
    },
  };

  return filtersWithoutCreatedFilter.length > 0
    ? {
        AND: [...filtersWithoutCreatedFilter, rangeInFilter],
      }
    : rangeInFilter;
};
